import React from 'react';
import Error from './Error';
import './styles.scss';

export default function SessionTimeout() {
    return (
        <Error headerTxt="Session Expired">
            <p>Your session has been expired due to inactivity.</p>
        </Error>
    );
}
